import { FC } from "react";
import { Alert } from "@mui/material";

export const PublishedAudienceLockedAlert: FC = () => (
	<Alert
		variant="outlined"
		severity="warning"
		sx={(theme) => ({
			my: "16px",
			"& .MuiAlert-message": {
				color: theme.palette.warning.main
			}
		})}
	>
		Once an announcement is published, you cannot change the audience.
	</Alert>
);
